import {useSelector} from "react-redux";
import {DeliveryThresholdHookInterface} from "../services/exports/Interfaces";
import useBasket from "./useBasket";
import {StoreInterface} from "../store/types";
import {ORDER_METHODS} from "../services/exports/Constants";

export default function useDeliveryThreshold(): DeliveryThresholdHookInterface {
  const { company } = useSelector((state: StoreInterface) => state.initialData);
  const { cached_order } = useSelector((state: StoreInterface) => state.order);
  const { total } = useBasket();

  function hasDeliveryThreshold(): boolean {
    return (
      cached_order?.method === ORDER_METHODS.DELIVERY
      && company?.has_delivery
      && company?.delivery_enabled
      && cached_order?.delivery_zone?.threshold > 0
    );
  }

  function getDeliveryThreshold(): number {
    try {
      return cached_order?.delivery_zone?.threshold;
    } catch (error) {}
  }

  function hasReachedDeliveryThreshold(): boolean {
    try {
      return total >= getDeliveryThreshold();
    } catch (error) {}
  }

  function getAmountNeededToReachDeliveryThreshold(): number {
    try {
      const diff = getDeliveryThreshold() - total;

      return diff > 0 ? diff : 0;
    } catch (error) {}
  }

  return {
    hasDeliveryThreshold: hasDeliveryThreshold(),
    hasReachedDeliveryThreshold: hasReachedDeliveryThreshold(),
    getDeliveryThreshold,
    amountNeededToReachDeliveryThreshold:
      getAmountNeededToReachDeliveryThreshold(),
  };
}
